var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spacer',{attrs:{"x":{default: 'm', m: 'l', xl : 'xl', xxl : 'xxl'}}},[_c(_vm.components[_vm.data.type],{tag:"component",attrs:{"data":_vm.data[_vm.data.type]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }